import React, { Suspense, lazy } from "react"
import LoadingOverlay from "components/Indicator/LoadingOverlay"
import { connect } from "react-redux"

const MainRegistration = lazy(() => import("./main"))

const Registration = (props) => {
  return (
    <div className={`${props.clientInfo.name}`}>
      <Suspense fallback={<LoadingOverlay />}>
        <MainRegistration />
      </Suspense>
    </div>
  )
}

const mapStateToProps = (state) => ({
  clientInfo: state.ClientReducer.clientInfo,
})

export default connect(mapStateToProps)(Registration)
